import type {
  ChatDynamicToolMessagePart,
  ChatMessage,
  ChatMessagePart,
  ChatReasoningMessagePart,
  ChatToolMessagePart,
} from '@mui/x-chat/types';

import { isDefined, isTruthy } from 'common';

import { isAgenticChatActivityActive } from './isActive';

export type AgenticChatActivityMessagePart =
  ChatDynamicToolMessagePart | ChatToolMessagePart | ChatReasoningMessagePart;

export function isAgenticChatActivityPart(
  part: ChatMessagePart | undefined
): part is AgenticChatActivityMessagePart {
  return (
    isDefined(part) &&
    (part.type === 'tool' || part.type === 'dynamic-tool' || part.type === 'reasoning')
  );
}

export function isAgenticChatActivityPartVisible(options: {
  part: ChatMessagePart | undefined;
  message: ChatMessage;
  index: number;
}): boolean {
  const { part, message, index } = options;
  return (
    isAgenticChatActivityPart(part) &&
    (part.type !== 'reasoning' ||
      isTruthy(part.text.trim().length) ||
      isAgenticChatActivityActive({ part, message, index }))
  );
}
